import React from 'react';

export const LoadingSpinner = () => (
  <div className="text-center py-20" data-testid="products-loading">
    <div className="inline-block animate-spin rounded-full h-16 w-16 border-4 border-orange-500 border-t-transparent"></div>
  </div>
);

export const LoadError = ({ message, onRetry }) => (
  <div className="text-center py-20" data-testid="products-error">
    <p className="text-xl text-red-600 mb-6">{message}</p>
    <button
      onClick={onRetry}
      className="bg-orange-500 hover:bg-orange-600 text-white px-8 py-3 rounded-full font-bold shadow-lg transition-colors"
      data-testid="products-retry-button"
    >
      Try Again
    </button>
  </div>
);
